// import React, { useState } from 'react';
// import axios from 'axios';
// import { GoogleLogin } from '@react-oauth/google';

// const LoginPage = ({ setToken, setUsername }) => {
//   // ---------------------------
//   // 스테이트: userId, password
//   // ---------------------------
//   const [userId, setUserId] = useState('');
//   const [password, setPassword] = useState('');

//   // ---------------------------
//   // 로컬 회원가입 (userId + password)
//   // ---------------------------
//   const register = async () => {
//     try {
//       // username 제거 → 서버에도 username 제외
//       const response = await axios.post('/register', { userId, password });
//       alert(response.data.message);
//     } catch (error) {
//       alert(error.response?.data?.message || 'Error registering user');
//     }
//   };

//   // ---------------------------
//   // 로컬 로그인 (userId + password)
//   // ---------------------------
//   const login = async () => {
//     try {
//       const response = await axios.post('/login', { userId, password });
//       setToken(response.data.token, response.data.displayName);
//       // displayName(표시용 username)은 서버에서 내려주더라도 UI에서 굳이 사용하지 않을 수 있음
//       setUsername(response.data.displayName || '');
//     //   alert(response.data.message);
//     } catch (error) {
//       alert(error.response?.data?.message || 'Error logging in');
//     }
//   };

//   // ---------------------------
//   // 구글 로그인 기존 로직
//   // ---------------------------
//   const handleGoogleSuccess = async (credentialResponse) => {
//     try {
//       const idToken = credentialResponse.credential;
//       const response = await axios.post('/auth/google', { idToken });
//       setToken(response.data.token);
//       setUsername(response.data.username);
//       alert(response.data.message || 'Google Login Success!');
//     } catch (err) {
//       console.error('Google Login Error:', err);
//       alert(err.response?.data?.message || 'Google Login Error');
//     }
//   };

//   const handleGoogleFailure = () => {
//     alert('Google Login Failed');
//   };

//   // ---------------------------
//   // UI
//   // ---------------------------
//   return (
//     <div style={{ width: '300px', margin: '0 auto', textAlign: 'center' }}>
//       <h1>User Authentication</h1>

//       {/* 로컬 가입/로그인 */}
//       <div style={{ marginBottom: '10px' }}>
//         <input
//           type="text"
//           placeholder="User ID (unique)"
//           value={userId}
//           onChange={(e) => setUserId(e.target.value)}
//           style={{ marginBottom: '5px', width: '100%' }}
//         />
//         <br />
//         <input
//           type="password"
//           placeholder="Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           style={{ marginBottom: '5px', width: '100%' }}
//         />
//       </div>

//       <div style={{ marginBottom: '10px' }}>
//         <button onClick={register} style={{ marginRight: '5px' }}>
//           Register
//         </button>
//         <button onClick={login}>
//           Login
//         </button>
//       </div>

//       <hr style={{ margin: '15px 0' }} />

//       {/* 구글 로그인 버튼 */}
//       <div>
//         <GoogleLogin onSuccess={handleGoogleSuccess} onError={handleGoogleFailure} />
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

// LoginPage.jsx
// import React, { useState } from 'react';
// import axios from 'axios';
// import { GoogleLogin } from '@react-oauth/google';

// const LoginPage = ({ setToken }) => {
//     // const [token, setToken] = useState(() => localStorage.getItem('token') || null);
//     // const [currentUsername, setCurrentUsername] = useState(localStorage.getItem('username') || '');
//     const [userId, setUserId] = useState('');
//     const [password, setPassword] = useState('');

//     // ---------------------------
//     // 로컬 회원가입 (userId + password)
//     // ---------------------------
//     const register = async () => {
//         try {
//             const response = await axios.post('/register', { userId, password });
//             alert(response.data.message);
//         } catch (error) {
//             alert(error.response?.data?.message || 'Error registering user');
//         }
//     };

//     // ---------------------------
//     // 로컬 로그인 (userId + password)
//     // ---------------------------
//     const login = async () => {
//         try {
//             const response = await axios.post('/login', { userId, password });
//             const { token, displayName } = response.data;
//             setToken(token, displayName); // handleLogin 호출
//             localStorage.setItem('token', newToken);
//             localStorage.setItem('username', username);            
//             alert(response.data.message);
//         } catch (error) {
//             alert(error.response?.data?.message || 'Error logging in');
//         }
//     };

//     // ---------------------------
//     // 구글 로그인 기존 로직
//     // ---------------------------
//     const handleGoogleSuccess = async (credentialResponse) => {
//         try {
//             const idToken = credentialResponse.credential;
//             const response = await axios.post('/auth/google', { idToken });
//             const { token, username } = response.data;
//             setToken(token, username); // handleLogin 호출
//             localStorage.setItem('token', newToken);
//             localStorage.setItem('username', username);
//             alert(response.data.message || 'Google Login Success!');
//         } catch (err) {
//             console.error('Google Login Error:', err);
//             alert(err.response?.data?.message || 'Google Login Error');
//         }
//     };

//     const handleGoogleFailure = () => {
//         alert('Google Login Failed');
//     };

//     // ---------------------------
//     // UI
//     // ---------------------------
//     return (
//         <div style={{ width: '300px', margin: '0 auto', textAlign: 'center' }}>
//             <h1>User Authentication</h1>

//             {/* 로컬 가입/로그인 */}
//             <div style={{ marginBottom: '10px' }}>
//                 <input
//                     type="text"
//                     placeholder="User ID (unique)"
//                     value={userId}
//                     onChange={(e) => setUserId(e.target.value)}
//                     style={{ marginBottom: '5px', width: '100%' }}
//                 />
//                 <br />
//                 <input
//                     type="password"
//                     placeholder="Password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     style={{ marginBottom: '5px', width: '100%' }}
//                 />
//             </div>

//             <div style={{ marginBottom: '10px' }}>
//                 <button onClick={register} style={{ marginRight: '5px' }}>
//                     Register
//                 </button>
//                 <button onClick={login}>
//                     Login
//                 </button>
//             </div>

//             <hr style={{ margin: '15px 0' }} />

//             {/* 구글 로그인 버튼 */}
//             <div>
//                 <GoogleLogin
//                     onSuccess={handleGoogleSuccess}
//                     onError={handleGoogleFailure}
//                 />
//             </div>
//         </div>
//     );
// };

// export default LoginPage;

import React, { useState } from 'react';
import axios from 'axios';

import SocialGoogle from './SocialGoogle';
import SocialKakao from './SocialKakao';
import Adfit from './Adfit';


const LoginPage = ({ handleLogin }) => {
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');

    // ---------------------------
    // 로컬 회원가입 (userId + password)
    // ---------------------------
    const register = async () => {
        try {
            const response = await axios.post('/users', { userId, password });
            alert(response.data.message);
        } catch (error) {
            alert(error.response?.data?.message || '회원가입에 실패했습니다');
        }
    };

    // ---------------------------
    // 로컬 로그인 (userId + password)
    // ---------------------------
    const login = async () => {
        try {
            const response = await axios.post('/auth/tokens', { userId, password });
            const { token, uuid, username } = response.data;
            handleLogin(token, uuid, username); // handleLogin 호출
        } catch (error) {
            alert(error.response?.data?.message || '로그인에 실패했습니다');
        }
    };


    // ---------------------------
    // UI
    // ---------------------------
    return (
      <div>
        <div className="auth-container">
          <h1>🌅 해돋이 - 2025</h1>
    
          {/* 로컬 가입/로그인 */}
          <div className="auth-input-container">
            <input
              className="auth-input"
              type="text"
              placeholder="User ID (unique)"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
            <input
              className="auth-input"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
    
          <div className="auth-button-container">
          <button className="auth-button" onClick={login}>
              로그인 하기
            </button>
            <button className="auth-button" onClick={register}>
              계정 만들기
            </button>

          </div>
    
          <hr className="auth-divider" />
    
          {/* 구글 로그인 버튼 */}
          {/* <div className="auth-google-login">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleFailure}
            />
          </div> */}
          <SocialGoogle
            handleLogin={handleLogin}
          />
          <SocialKakao
            handleLogin={handleLogin}
          />

        </div>
      {/* <Adfit 
      unit="DAN-kPuc0Q7F5YVx3ZoT"
      width="320"
      height="100"
      /> */}
  </div>
      );
};

export default LoginPage;
